import { Box, Link, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import Logo from '../../resources/images/logos/FullColourLogo.png';
import WomanWithTablet from '../../resources/images/stock/WomanWithTablet.jpg';
import Footer from '../../components/ui/footer';

//Center login Box on screen with background image.
const AuthLayout = (props) => {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      flexDirection={'column'}
      style={{
        minHeight: '100vh',
        backgroundImage: `url(${WomanWithTablet})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover'
      }}>
      <Box
        display={'flex'}
        flexDirection={'column'}
        flexGrow={2}
        style={{
          backgroundColor: theme.palette.background.backdrop
        }}
        justifyContent={'center'}
        alignItems={'center'}>
        <Box
          component="img"
          sx={{
            height: 80
          }}
          alt="Fairtree"
          src={Logo}
        />

        <Box width={'100%'}>{props.children}</Box>
      </Box>
      <Footer />
    </Box>
  );
};

export default AuthLayout;

//props.children;
